import { isRunningInIframe } from '../isRunningInIframe/isRunningInIframe';
import { BOOKINGS_APP_DEF_ID, BOOKINGS_CALENDAR_SECTION_ID, BOOKINGS_CHECKOUT_SECTION_ID, BOOKINGS_FORM_SECTION_ID, BOOKINGS_SERVICE_PAGE_SECTION_ID } from '../const';
export async function isBookingsSectionInstalled(wixCodeApi, sectionId) {
  if (isRunningInIframe()) {
    return new Promise(resolve => {
      window.Wix.isAppSectionInstalled(sectionId, {
        appDefinitionId: BOOKINGS_APP_DEF_ID
      }, isInstalled => {
        resolve(isInstalled);
      });
    });
  }
  return Promise.resolve(wixCodeApi.site.isAppSectionInstalled({
    sectionId,
    appDefinitionId: BOOKINGS_APP_DEF_ID
  }));
}
export function isBookCheckoutInstalled(wixCodeApi) {
  return isBookingsSectionInstalled(wixCodeApi, BOOKINGS_CHECKOUT_SECTION_ID);
}
export function isBookingCalendarInstalled(wixCodeApi) {
  return isBookingsSectionInstalled(wixCodeApi, BOOKINGS_CALENDAR_SECTION_ID);
}
export function isBookingFormInstalled(wixCodeApi) {
  return isBookingsSectionInstalled(wixCodeApi, BOOKINGS_FORM_SECTION_ID);
}
export function isServicePageInstalled(wixCodeApi) {
  return isBookingsSectionInstalled(wixCodeApi, BOOKINGS_SERVICE_PAGE_SECTION_ID);
}
//# sourceMappingURL=isBookingsSectionInstalled.js.map